// extracted by mini-css-extract-plugin
module.exports = {"clickable":"avatar_clickable__8h5fb"};